import "./styles.scss"

interface IPropsProgress {
  min: number,
  max: number,
  current: number,
  legend: string
}

const Progress = ({ min, max, current, legend }: IPropsProgress) => {
  const width = (current/max)*100
  return (
    <div className="progress">
      <header>
        <p className="paragraph paragraph--sm">{min}</p>
        <p className="paragraph paragraph--sm">{max}</p>
      </header>
      <div className="progress__bar">
        <div
          className="progress__fill"
          style={{ width: `${width}%` }}
        ></div>
      </div>
      <p className="progress__text">{legend}</p>
    </div>
  )
}

export default Progress